var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c-.79 0-1.428.67-1.428 1.5v.9c-3.26.694-5.715 3.722-5.715 7.35v.881a9.285 9.285 0 0 1-2.165 5.982l-.33.389a1.564 1.564 0 0 0-.237 1.612c.228.54.741.886 1.304.886h17.143c.562 0 1.071-.347 1.303-.886a1.555 1.555 0 0 0-.236-1.612l-.33-.39a9.275 9.275 0 0 1-2.166-5.98V9.75c0-3.628-2.455-6.656-5.714-7.35v-.9C11.429.67 10.79 0 10 0Zm2.022 23.123A3.079 3.079 0 0 0 12.857 21H7.143c0 .797.3 1.56.835 2.123A2.79 2.79 0 0 0 10 24a2.79 2.79 0 0 0 2.022-.877Z"
  })));
};
export default SvgBell;